import React, { useEffect } from "react";
import "./OurProjects.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function OurProjects() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  const projects = [
    {
      title: "Health Care",
      img: "/health.webp",
      desc:
        "We plan to expand our healthcare initiatives by organizing regular medical camps, offering early diagnosis support, and helping families access essential treatment. Our vision is to build healthier communities through preventive care and timely medical assistance.",
    },
    {
      title: "OurCountry OurPeople HealthCare Center",
      img: "/hospital1.png",
      desc:
        "Develop professional, technical, and medical institutions in compliance with statutory and regulatory bodies. Establish and support hospitals, health centers, orphanages, homes for the aged, and welfare shelters.",
    },
    {
      title: "Welfare & Relief",
      img: "/relief.jpg",
      desc:
        "Collaborate with governments, NGOs, and international organizations to design and implement welfare programs. Offer relief and assistance during natural calamities and support rehabilitation for vulnerable communities. Support animal welfare, poverty relief, and provide food, clothing, shelter, and education to the needy.",
    },
    {
      title: "Education",
      img: "/edu.webp",
      desc:
        "Promote education by establishing schools, colleges, universities, and training centers across disciplines. Provide skill training, scholarships, and incentives to empower students, youth, women, and disadvantaged groups.",
    },
    {
      title: "Building a Future Home for Children",
      img: "/Gal7.jpg",
      desc:
        "We aim to open a dedicated Children’s Home in the near future to provide a safe, loving, and structured environment for vulnerable children. Our mission is to ensure that every child receives proper education, nutritious food, emotional care, and the guidance needed to build a bright and confident future. This home will become a place where children feel protected, valued, and encouraged to dream big.",
    },
    {
      title: "Women Empowerment",
      img: "/emp.jpg",
      desc:
        "Women empowerment is the foundation of a just, inclusive, and progressive society. It focuses on enabling women to realize their full potential by providing equal opportunities in education, healthcare, employment, and leadership. When women are empowered, families grow stronger, communities become resilient, and nations move forward with balance and compassion.",
    },
  ];

  return (
    <div className="projects-page">

      {/* Header Row */}
      <div className="projects-header" data-aos="fade-right">
        <p className="breadcrumb">Home &nbsp;›&nbsp; Our Projects</p>
      </div>

      {/* Intro Section */}
      <div className="intro-section" data-aos="fade-up">
        <h3 data-aos="fade-up" data-aos-delay="100">WHAT WE DO IN A FUTURE</h3>
        <div className="what-tittle" data-aos="fade-up" data-aos-delay="200"></div>

        <p className="intro-text" data-aos="fade-up" data-aos-delay="300">
          Since the year 2000, our organization has been working across three key
          areas—education, healthcare, and women empowerment. Our mission is to make
          quality learning accessible, support families during medical challenges,
          and create pathways for women to achieve economic independence.
        </p>

        <p className="intro-text small" data-aos="fade-up" data-aos-delay="400">
          We collaborate with volunteers, partners, and community groups to design
          impactful programs that reach deserving individuals across Tamil Nadu.
          Every project we undertake is built on empathy, sustainability, and the
          belief that every person deserves an equal chance at a better life.
        </p>
      </div>

      {/* Projects Grid */}
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            className="project-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 150} // staggered animation
          >
            <img src={project.img} alt={project.title} />
            <h4>{project.title}</h4>
            <p>{project.desc}</p>
            <span className="read-more">Read More ➝</span>
          </div>
        ))}
      </div>
    </div>
  );
}
